import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import api from '../lib/api'
import { useEffectiveUser } from './useEffectiveUser'

export interface OpportunityEngagement {
  saved_demand_ids: number[]
  reminders_enabled: boolean
}

export function useOpportunityEngagement() {
  const user = useEffectiveUser()
  return useQuery({
    queryKey: ['opportunity-engagement', user?.id],
    enabled: !!user,
    queryFn: async () => (await api.get<OpportunityEngagement>('/opportunity-engagement')).data,
  })
}

export function useSaveOpportunity() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async ({ id, saved }: { id: number; saved: boolean }) => {
      if (saved) await api.put(`/opportunity-engagement/saved/${id}`)
      else await api.delete(`/opportunity-engagement/saved/${id}`)
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['opportunity-engagement'] }),
  })
}

export function useOpportunityReminders() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (enabled: boolean) => {
      await api.put('/opportunity-engagement/preferences', { reminders_enabled: enabled })
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['opportunity-engagement'] }),
  })
}
